


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class ExchangeRateView extends Vue {
  public items: Common.ExchangeRate[] = new Array(0);
  public params: Common.ExchangeRateQuery = new Common.ExchangeRateQuery();
  public importQuery = new Common.ExchangeRateImportQuery('計上レート');
  public exportQuery = new Common.ExchangeRateExportQuery('計上レート', this.params);
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseTrade: boolean = false;
  @Prop() public auditNo:string;

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration =new Common.GridConfiguration([],0, 'grid');


  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'currency', text: '通貨' },
    { value: 'startDate', text: '適用日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;    
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('通貨', 120),
      new Common.GridItemConfiguration('適用日', 120),
      new Common.GridItemConfiguration('計上レート', 120),
      new Common.GridItemConfiguration('評価替区分', 120,this.hasLicenseTrade),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseTrade = this.hasLicenseTrade;
    this.exportQuery.hasLicenseTrade = this.hasLicenseTrade;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  public async onCreate(obj: Common.ExchangeRate) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.ExchangeRate):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.ExchangeRate):boolean{
    return item.state == Common.MasterBaseStatus.NotPosted;
  }
}
